import { Stack, Theme } from "@mui/material";
import { SxProps } from "@mui/material/styles";
import { ReactElement, ReactNode } from "react";

/**
 * Page Footer
 * Could include global page or bulk actions.
 */
export type FullPageContainerFooterProps = {
  children: ReactNode;
  sx?: SxProps<Theme>;
};

export function FullPageContainerFooter({
  children,
  sx,
}: FullPageContainerFooterProps): ReactElement {
  return (
    <Stack
      sx={[
        {
          position: "fixed",
          left: 0,
          bottom: 0,
          width: "100%",
          px: 4,
          py: 2,
          borderTop: "4px solid",
          borderColor: "stroke.transparentDim",
          marginTop: "auto",
          transition: (theme) => theme.transitions.create("width"),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Stack>
  );
}

FullPageContainerFooter.displayName = "FullPageContainerFooter";
